import { HALF_PI } from "./math";

export const ON_CLICK_OFFSET = 0.01;

export const LED_DEFAULTS = {
    intensity: 15,
};

export const COLORS = {
    outline: 0x008d24,
    sceneBackground: "#9C9C9C",
};

export const ORBIT_CONTROLS_DEFAULTS = {
    maxAzimuthAngle: HALF_PI,
    minAzimuthAngle: -HALF_PI,
    maxDistance: 10,
    minDistance: 2,
    // enablePan: false,
};

export const CAMERA_FOV = 2 * Math.atan(3 / 2 / 5) * (180 / Math.PI);
export const SIN_HALF_FOV = Math.sin(0.5 * CAMERA_FOV * (Math.PI / 180));

export const OUTLINE_DEFAULTS = {
    blur: true,
    visibleEdgeColor: COLORS.outline,
    hiddenEdgeColor: COLORS.outline,
    edgeStrength: 10,
    width: 1000,
};

export const EFFECT_COMPOSER_DEFAULTS = {
    autoClear: false,
    multisampling: 8,
};

export const SECTION_DEFAULTS = {
    width: 0.9,
    height: 2.9,
};

export const SERIF = 0.05;

export const HEADER_HEIGHT = 59;

export const REGEXP_POLKA_STOL = /стол|полка|подвес/i;
export const REGEXP_CABINET = /шкаф/i;
export const REGEXP_BRACKET = /кронштейн/i;
export const BOTTOM_OFFSET = 0;
export const SIDE_OFFSET = 1000;
export const TOP_OFFSET = 1000;
export const DEFAULT_HEIGHT = 1500;
export const RULER_BOTTOM_OFFSET = 200;
export const RULER_RIGHT_OFFSET = 200;
export const BEAM_TOP_OFFSET = 50;
export const BEAM_LEFT_OFFSET = 50;

export const MIN_TOTAL_LENGTH = 640; //FIXME проверить и удалить, параметры переехали в room
export const MIN_TOTAL_HEIGHT = 800; //FIXME проверить и удалить, параметры переехали в room

export const roomConstants = {
    //константы для комнаты
    maxSize: {
        //максимальные размеры
        length: 12000,
        height: 5000,
        depth: 12000,
    },
    minSize: {
        //минимальные размеры
        length: 640,
        height: 800,
        depth: 640,
    },
};

export const shelfConstants = {
    //константы для стеллажа
    minSize: {
        //минимальные размеры
        length: 600,
        height: 500,
        sideIndent: 20,
        offsetCeiling: 0,
    },
};

export const WIREFRAME_THRESHOLD = 5000;
